export function getValue(key) {
    return window.sessionStorage.getItem(key);
}

export function setValue(key,val) {
    return window.sessionStorage.setItem(key,val);
}

export function remove(key) {
    return window.sessionStorage.removeItem(key)
}


